var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconName)?_c('AuroraArtIcon',{staticClass:"aurora-category-icon",attrs:{"name":_vm.iconName}}):_c('img',{staticClass:"aurora-category-image",attrs:{"src":_vm.imageUrl,"alt":""},on:{"error":function($event){return _vm.$emit('error', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }